// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import Antd from 'ant-design-vue'
import { message } from 'ant-design-vue'
import './theme/index.less'
import VueI18n from 'vue-i18n'
import LangENUS from './i18n/en-us'
import LangZHCN from './i18n/zh-cn'
import moment from 'moment'
import Viewer from 'v-viewer'
import store from 'store'
import 'viewerjs/dist/viewer.css'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { getCookie } from './util/util.js'
import HTMLDecode from './common/HTMLDecode'
import directives from './common/directives'
import { envConfig } from './common/global'
import ElementUI from 'element-ui'
import Router from 'vue-router'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
axios.defaults.withCredentials = true
axios.defaults.crossDomain = true
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.withCredentials = false
Vue.prototype.$http = axios
Vue.prototype.HTMLDecode = HTMLDecode
Vue.config.productionTip = false
Vue.prototype.moment = moment
Vue.use(Antd)
Vue.use(VueI18n)
Vue.use(Viewer)
Vue.use(VueQuillEditor)
Vue.use(directives)

let api
let HallApi
let insuranceApi
let frontUrl
let ssoUrl
let directSaasUrl
const apibx = 'http://192.168.1.186:8870'
Vue.prototype.apibx = apibx
// npm run dev环境
const isHttps = window.location.href.indexOf('https') === -1 ? 'http' : 'https'
if (process.env.NODE_ENV === 'development') {
  api = '/api/'
  HallApi = '/admin/'
  // api = 'http://admin.ems.369zhan.com/'
  // api = 'http://localhost:81/'
  // insuranceApi = 'http://192.168.1.24:8870/'
  insuranceApi = 'http://expo-ins.369zhan.com/'
  // insuranceApi = process.env.INSURANCE_URL
  // frontUrl = isHttps + process.env.FRONT_URL
  frontUrl = 'http://localhost:8080/#/'
  // ssoUrl = 'http://account.ems.369zhan.com/'
  ssoUrl = 'http://admin.saas-poly.test.369zhan.com/nesso/'
  // ssoUrl = 'http://192.168.1.149:8010/nesso/' // 段宇霖本地测试环境

  directSaasUrl = 'http://admin.saas-poly.test.369zhan.com/'
  // 编译环境
} else {
  api = ((process.env.BASE_API.indexOf('://') > -1) ? isHttps : '') + process.env.BASE_API
  HallApi = ((process.env.BASE_API.indexOf('://') > -1) ? isHttps : '') + process.env.BASE_API
  insuranceApi = ((process.env.INSURANCE_URL.indexOf('://') > -1) ? isHttps : '') + process.env.INSURANCE_URL
  frontUrl = ((process.env.FRONT_URL.indexOf('://') > -1) ? isHttps : window.location.origin) + process.env.FRONT_URL
  ssoUrl = ((process.env.ssoUrl.indexOf('://') > -1) ? isHttps : window.location.origin) + process.env.ssoUrl
  directSaasUrl = ((process.env.DIRECT_SAAS_URL.indexOf('://') > -1) ? isHttps : '') + process.env.DIRECT_SAAS_URL
}

Vue.prototype.api = api
Vue.prototype.HallApi = HallApi
Vue.prototype.insuranceApi = insuranceApi
Vue.prototype.$grooveStore = store

// 匿名模板测试环境id
Vue.prototype.$CORD_ID = 1198 // 模板名称:我的新匿名模板
// Vue.prototype.$CORD_ID = process.env.NODE_ENV === 'production' ? 1197 : 1125

// 主场地址
Vue.prototype.frontUrl = frontUrl
Vue.prototype.ssoUrl = ssoUrl
Vue.prototype.directSaasUrl = directSaasUrl

function Decode(response) {
  const json = JSON.stringify(response)
  const res = HTMLDecode.HTMLDecode(json)
  return JSON.parse(res)
}
Vue.prototype.Decode = Decode

/* 拦截器 */
// 添加请求拦截器
axios.interceptors.request.use(
  config => {
    // 在发送请求之前做某事
    if (
      config.url.indexOf('auth/login') > -1 ||
      config.url.indexOf('a/ssoLogin') > -1 ||
      config.url.indexOf('userController/register') > -1 ||
      config.url.indexOf('auth/logout') > -1
    ) {
      config.params = {
        __ajax: true,
        mobileLogin: true,
        nowTime: new Date().valueOf(),
        ...config.params
      }
      return config
    } else {
      const ehsAgencyId = store.get('ehsAgencyId') || localStorage.getItem('ehs.agency-id')
      if (ehsAgencyId !== undefined && ehsAgencyId !== '' && ehsAgencyId !== null) {
        config.headers['agency-id'] = ehsAgencyId // 机构ID
      }
      const tenantId = localStorage.getItem('TENANT_ID')
      if (tenantId && tenantId !== undefined && tenantId !== '') {
        config.headers['tenant-id'] = tenantId // 租户ID
      }
      config.params = {
        JSESSIONID: getCookie('JSESSIONID'),
        __ajax: true,
        mobileLogin: false,
        nowTime: new Date().valueOf(),
        ...config.params
      }
      config.headers['Isolation'] = true
      return config
    }
  },
  error => {
    // 请求错误时做些事
    return Promise.reject(error)
  }
)

// 添加响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.resultCode === -3) {
      if (
        response.data.data.body.requestUrl === '/a/login' ||
        response.data.data.body.requestUrl === '/a/login_ajax' ||
        response.data.data.body.requestUrl === '/a/login?_ajax'
      ) {
        return
      } else if (response.data.data.body.requestUrl === '/a/api/user/get') {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('booth')
        console.log('user401跳转******')
      } else {
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('booth')

        window.location.href =
          ssoUrl +
          'auth/getVerificationToken?tokenUrl=' +
          window.location.href.split('/#/')[0] +
          `/%23/&platformName=${envConfig.platformName}`
        console.log('401跳转******')
      }
    }
    // http 反转义
    if (
      !response.config.url.split('api/orderPay/payOrder').length ||
      !response.config.url.split('api/orderPay/continuePay').length
    ) {
      const json = JSON.stringify(response)
      const res = HTMLDecode.HTMLDecode(json)
      response = JSON.parse(res)
    }
    return response
  },
  error => {
    const { response } = error
    const { status, data } = response
    switch (status) {
      case 401:
        sessionStorage.removeItem('user')
        sessionStorage.removeItem('booth')
        window.location.href =
          ssoUrl +
          'auth/getVerificationToken?tokenUrl=' +
          window.location.href.split('/#/')[0] +
          `/%23/&platformName=${envConfig.platformName}`
        break
      case 500:
        message.error(data.subMessage || data.message || '系统异常', 3)
        break
      default:
        message.error(data.subMessage || data.message || '系统异常', 3)
        break
    }
    // 请求错误时做些事
    console.log('******************')
    console.log(error)
    return Promise.reject(error)
  }
)
// Viewer默认设置
Viewer.setDefaults({
  Options: {
    inline: false,
    button: true,
    navbar: true,
    title: true,
    toolbar: true,
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true,
    url: 'data-source'
  }
})

const i18n = new VueI18n({
  locale: 'zh-cn',
  messages: {
    'en-us': LangENUS,
    'zh-cn': LangZHCN
  }
})

// val被格式化的值
// lang  @zh:'@/i18n/zh-cn/dataI18n/
// lang  @en:'@/i18n/en-us/dataI18n/
Vue.filter('dataI18n', (val, lang) => {
  if (sessionStorage.getItem('locale') === 'zh-cn') {
    return lang.zh[val] || val
  } else {
    return lang.en[val] || val
  }
})
/* 重复路由报错问题 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js